module.exports = __webpack_public_path__ + "img/ic-chat.03033471.png";